import { LocaleKeys } from "src/internationalization/CustomIntlProvider";
import { AlertStatus, AlertValidationDecision } from "src/types/alert";

export const ALERT_STATUS_LABELS: Record<AlertStatus, LocaleKeys> = {
  closed: "page.alert.tab.synthesis.widget.alert.status.closed",
  notAssigned: "page.alert.tab.synthesis.widget.alert.status.not.assigned",
  assigned: "page.alert.tab.synthesis.widget.alert.status.assigned",
  canceled: "page.alert.tab.synthesis.widget.alert.status.canceled",
};

export const ALERT_VALIDATION_DECISION_LABELS: Record<AlertValidationDecision, LocaleKeys> = {
  compliant: "alert.decision.tag.compliant",
  fraudPrevented: "alert.decision.tag.fraudPrevented",
  provenFraudWithFinancialLoss: "alert.decision.tag.provenFraudWithFinancialLoss",
  provenFraudWithNoFinancialLoss: "alert.decision.tag.provenFraudWithNoFinancialLoss",
};
